varying vec3 vPosition;
varying vec3 vNormal;
varying vec2 vUv;


/* NOTE: THREE.ShaderMaterial の uniforms で使用される変数の説明
    normal: 頂点の法線ベクトル（面に垂直なベクトル）
    normalMatrix: 法線をワールド座標に変換するマトリックス
    normalize(): ベクトルの長さを1に正規化
*/
void main() {
  vPosition = position;
  vNormal = normalize(normalMatrix * normal);
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}